import { useContext, useEffect, useState, useCallback } from "react";
import GlobalContext from "../common/Context";

const useFirebaseAuthentication = () => {
  const { setAuthError, firebaseService, setUserProfile, setDocs } = useContext(GlobalContext);

  const [idToken, setIdToken] = useState();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const getAPIDocs = useCallback(async () => {
    try {
      const apiResponse = await firebaseService.getDocs();
      setDocs(apiResponse);
    } catch (error) {
      console.error("Error fetching API response:", error);
    }
  }, [firebaseService, setDocs]);

  const badSignIn = useCallback(async () => {
    console.error("Bad Sign In");
    setIdToken(null);
    await firebaseService.getAuth().signOut();
    setAuthError({ code: "auth/no-access" });
  }, [firebaseService, setAuthError]);

  useEffect(() => {
    setIsAuthenticated(!!idToken);
  }, [idToken]);

  useEffect(() => {
    if (isAuthenticated) {
      getAPIDocs();
    }
  }, [isAuthenticated, getAPIDocs]);

  useEffect(() => {
    firebaseService.getAuth().onAuthStateChanged(async (user) => {
      if (user) {
        setIsCheckingAuth(true);

        const [profile, fbUser] = await Promise.all([
          firebaseService.getProfileByEmail(user.email),
          firebaseService.adminGetUserByEmail(user.email),
        ]);

        if (!profile || !fbUser) {
          return badSignIn();
        }
        if (!fbUser.customClaims?.wa && !fbUser.customClaims?.medidas) {
          return badSignIn();
        }

        setUserProfile(profile);
        setIdToken(user.getIdTokenResult());
      } else {
        setUserProfile({});
        setIdToken(null);
      }
      setIsCheckingAuth(false);
    });
  }, [badSignIn, firebaseService, setUserProfile]);

  return {
    isAuthenticated,
    isCheckingAuth,
  };
};

export default useFirebaseAuthentication;
